import { render, staticRenderFns } from "./Breadcrumbs.vue?vue&type=template&id=5fd5c5fb&"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js&"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5fd5c5fb', component.options)
    } else {
      api.reload('5fd5c5fb', component.options)
    }
    module.hot.accept("./Breadcrumbs.vue?vue&type=template&id=5fd5c5fb&", function () {
      api.rerender('5fd5c5fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layout/Breadcrumbs.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Breadcrumbs.vue
// module id = Dez2
// module chunks = 0